import type { EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate } from '@/common/graphql';

import { DateWithCount } from '../DateWithCount';

export const DetailDescriptionEmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate = ({
  reason,
}: {
  reason: Pick<
    EmployeeAlertLastContractEndDateNotSameAsLastJobHistoryEndDate,
    'lastContractEndDate' | 'lastJobHistoryEndDate'
  >;
}) => (
  <>
    <div>
      <DateWithCount prefix="Last contract end date" date={reason.lastContractEndDate} />
    </div>
    <div>
      <DateWithCount prefix="Last job history end date" date={reason.lastJobHistoryEndDate} />
    </div>
  </>
);
